import React from 'react';
import '../../styles/SearchBar.css';

function SearchBar({ value, onChange, placeholder = 'ابحث عن محل...' }) {
  return (
    <div className="search-bar">
      <svg className="search-bar-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
        <circle cx="11" cy="11" r="8" />
        <path d="M21 21l-4.35-4.35" strokeLinecap="round" />
      </svg>
      <input
        type="search"
        className="search-bar-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label="بحث عن محل"
      />
    </div>
  );
}

export default SearchBar;
